import { useEffect } from "react";

export const usePageTitleEffect = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};
